import { API_LIST_LIMIT, FrontierService } from '@api';
import { QueryFunctionContext, useInfiniteQuery } from '@tanstack/react-query';
import { InventoryQueryKeys } from '@Inventory/services/queryKeys';
import { InventoryFilterOptionsInput } from '@api/gql/graphql';
import { inventoryFilterOptionsDocument } from './use-inventory-filter-options.gql';

export function useInventoryFilterOptions(filter: InventoryFilterOptionsInput, enabled = true) {
  const fetch = ({ pageParam = 0 }: QueryFunctionContext) =>
    FrontierService.request(inventoryFilterOptionsDocument, {
      filter,
      pagination: {
        take: API_LIST_LIMIT,
        offset: pageParam,
      },
    });

  return useInfiniteQuery([InventoryQueryKeys.InventoryFilterOptions, JSON.stringify({ filter })], fetch, {
    keepPreviousData: true,
    getNextPageParam: (lastPage, pages) => {
      if (!lastPage.inventoryFilterOptions.hasMore) return;
      return pages.length * API_LIST_LIMIT;
    },
    enabled,
  });
}
